module.exports = __webpack_public_path__ + "static/img/icon-pro1.1415652.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-pro1.jpg
// module id = diVm
// module chunks = 21